import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreHref,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {moreHref && (
        <Link
          to={moreHref}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}